
import React from 'react';
import FadeIn from '../../components/FadeIn';
import SEO from '../../components/SEO';

const PrivacyPolicy = () => {
    return (
        <div className="bg-white pt-32 pb-20 px-4 sm:px-6 lg:px-8">
            <SEO title="Privacy Policy | BPO Consultants" description="Our commitment to protecting your data." />
            <FadeIn className="max-w-4xl mx-auto">
                <h1 className="text-4xl font-bold text-[#20222D] mb-8">Privacy Policy</h1>
                <div className="prose prose-lg text-gray-600">
                    <p className="mb-4">Last updated: {new Date().toLocaleDateString()}</p>
                    <p className="mb-6">At BPO Consultants, we take your privacy seriously. This Privacy Policy explains how we collect, use, and protect your personal information.</p>

                    <h2 className="text-2xl font-bold text-[#20222D] mt-8 mb-4">1. Information We Collect</h2>
                    <p className="mb-4">We collect information you provide directly to us, such as when you fill out a contact form, sign up for a newsletter, or register for a course. This may include your name, email address, phone number, and company name.</p>

                    <h2 className="text-2xl font-bold text-[#20222D] mt-8 mb-4">2. How We Use Your Information</h2>
                    <p className="mb-4">We use the information we collect to provide, maintain, and improve our services, to communicate with you, and to personalize your experience.</p>

                    <h2 className="text-2xl font-bold text-[#20222D] mt-8 mb-4">3. Data Security</h2>
                    <p className="mb-4">We implement appropriate technical and organizational measures to protect your personal data against unauthorized access, alteration, disclosure, or destruction.</p>

                    <h2 className="text-2xl font-bold text-[#20222D] mt-8 mb-4">4. Contact Us</h2>
                    <p className="mb-4">If you have any questions about this Privacy Policy, please contact us at info@bpoconsultants.ph.</p>
                </div>
            </FadeIn>
        </div>
    );
};

export default PrivacyPolicy;
